import { BaseWithFollowUsLayout } from "../layouts";
import { Container, InlineLink, NextPageWithLayout } from "@akte-mord/common";
import { Paper, Typography } from "@mui/material";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import i18nConfig from "../../next-i18next.config";
import Link from "next/link";
import React from "react";
import type { GetStaticProps } from "next";

const Contact: NextPageWithLayout = () => (
  <Container>
    <Typography variant="h1">Des questions sur nos enquêtes ?</Typography>
    <Typography variant="body1" paragraph>
      Si vous avez des questions, des suggestions ou des critiques à propos de nos jeux d’enquête,
      contactez-nous à <InlineLink href="mailto:mail@cold-case.fr">mail@cold-case.fr</InlineLink>.
    </Typography>

    <Paper sx={{ p: { xs: 2, sm: 4 }, mx: { xs: -2, sm: 0 }, mt: { xs: 2, md: 4 } }}>
      Si votre jeu est incomplet, nous vous enverrons les documents manquants le plus rapidement
      possible. En cas d’urgence, vous pouvez télécharger tout{" "}
      <Link passHref href="/aide/document-manquant">
        <InlineLink>document manquant </InlineLink>
      </Link>{" "}
      au format PDF grâce à votre code d’accès.
    </Paper>
  </Container>
);

Contact.getLayout = (page) => (
  <BaseWithFollowUsLayout
    description="Contactez-nous pour toute question, suggestion ou critique à propos de nos jeux d’enquête."
    title="Contact | COLD CASE"
  >
    {page}
  </BaseWithFollowUsLayout>
);

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(locale ? await serverSideTranslations(locale, ["c-common", "c-user-consent-management"], i18nConfig) : {}),
    },
  };
};

export default Contact;
